module.exports = __webpack_public_path__ + "static/img/PN.526a29b8.svg";